import React from 'react';
import { makeStyles } from 'tss-react/mui';

import NavBar from 'components/NavBar';

const useStyles = makeStyles()((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    content: {
        padding: theme.spacing(1),
        flex: 1,
    },
}));

interface PageProps extends React.PropsWithChildren {
    style?: React.CSSProperties;
    className?: string;
}

const Page: React.FunctionComponent<PageProps> = ({
    style,
    className,
    children,
}) => {
    const { classes } = useStyles();

    return (
        <div className={classes.root}>
            <NavBar />
            <div
                className={`${classes.content} ${className ?? ''}`}
                style={style}
            >
                {children}
            </div>
        </div>
    );
};

Page.displayName = 'Page';
export default Page;
